export default __webpack_public_path__ + "static/media/wifi_icon.a6918a02.svg";